import { Component, useEffect } from "react";
import { Toaster } from "sonner";
import "./App.css";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import About from "./components/About";
import Follow from "./components/Follow";
import Footer from "./components/Footer";
import StickyCTA from "./components/StickyCTA";
import AdminPage from "./pages/AdminPage";
import PrivacyPage from "./pages/PrivacyPolicy";
import { initLenis } from "./lib/smooth";

class ErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div style={{ background: "#E0AEBA", color: "#292800", minHeight: "100vh", padding: 48, fontFamily: "Outfit, sans-serif" }}>
                    Something went wrong. Please refresh the page.
                </div>
            );
        }
        return this.props.children;
    }
}

export default function App() {
    const route = window.location.pathname;

    useEffect(() => {
        if (route !== "/") return;
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (!reduce) initLenis();
    }, [route]);

    return (
        <ErrorBoundary>
            {route === "/admin" ? (
                <AdminPage />
            ) : route === "/privacy" ? (
                <PrivacyPage />
            ) : (
                <div className="min-h-screen bg-blush text-garden font-body antialiased">
                    <div className="grain" aria-hidden="true" />
                    <Nav />
                    <main>
                        <Hero />
                        <About />
                        <Follow />
                    </main>
                    <Footer />
                    <StickyCTA />
                </div>
            )}
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#8B263E",
                        color: "#E0AEBA",
                        border: "1px solid rgba(217, 79, 112, 0.6)",
                        borderRadius: "0",
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
        </ErrorBoundary>
    );
}
